import {lutify, UI} from "@/assets/js/Boot";

export default class LUTcontrol {
	constructor() {
		this.opacity = {
			minValue: 0,
			maxValue: 100,
		};
	}

	async addBlock(blockNum = lutify.blocks.length, data) {
		UI.createAdjustmentBlockTemplate("lut", blockNum, data);
		let $element = $(UI.getAdjustmentBlock(blockNum));
		$element.find(".lut-selector__items-container").hide();

		UI.scrollToBlock(lutify.activeBlock);

		$element.on("click", e => {
			e.stopImmediatePropagation();
			lutify.selectedPreviewCategory = data.category;
			this.showPreviews($element);
		});

		$element.find(".btn-reset-block").off("click").on("click", e => this.resetBlock($element, e));
		$element.find(".btn-reset-selection").on("click", e => this.removeLutSelection(e));
		$element.find(".opacity_slider").on("input", _ => this.opacitySliderHandler($element));
		$element.find(".opacity-input").on("change", _ => this.opacityInputHandler($element));

		$element.find(".lut-selector__label-container").on("click", e => {
			// e.stopPropagation();
			this.toggleControlSelector($(e.currentTarget));
		});

		blocks.add({
			name: data.category,
			control: data.control,
			passes: [this.addPass()],
			blockNum,
			blendingMode: 0,
			blendingModeName: "Normal",
			selectedPreview: null,
			selectedPreviewName: null,
			opacity: 100,
			...(data.product) && { product: data.product },
		});

		UI.appendBlockLoadingSpinner($element);
		lutPreviewer.showPlaceholderPreviews();
		await this.load(data);
		UI.removeBlockLoadingSpinner($element);

		$element.find(".expand_options").trigger("click", [false]);
		UI.scrollToBlock(blockNum);

		this.updateLutsDropdownList($element, data);
		UI.attachTemporaryLUTSelectionHandler();
	}

	// NOTE: This can be refactored - LUTcontrol, smartWarmth and TealandOrange use same loading logic.
	// Only with LUTcontrol, there is additional line: lutPreviewer.createPreviews
	async load(data) {
		// Initially when loading for first time.
		if (typeof luts.loaded[data.control].controls[data.category] == "undefined") {
			luts.loaded[data.control].controls[data.category] = { status: "idle", total: null, fetched: null };
			luts[data.control][data.category] = [];
			// let totalCount = await luts.getLUTcontrolsTotalCount(data.category);
			// luts.loaded[data.control].controls[data.category].total = parseInt(totalCount);
		}

		// When all luts fetched, don't fetch again.
		if (luts.loaded[data.control].controls[data.category].status == "loaded") return;

		if (luts.loaded[data.control].controls[data.category].status == "idle") {
			luts.loaded[data.control].controls[data.category].status = "loading";

			let fetchedLUTs = await luts.fetchLUTcontrols(data);
			await luts.load(fetchedLUTs, luts[data.control][data.category]);

			luts[data.control][data.category].forEach((LUT, key) => {
				LUT.control = data.control;
				LUT.category = data.category;
				LUT.lutId = key + 1;
				// LUT.filename = LUT.name;
				// LUT.categoryType = 'LUT';
				// LUT.blockType = 'LUT';
			});

			luts.loaded[data.control].controls[data.category].fetched += fetchedLUTs.length;

			lutPreviewer.createPreviews(luts[data.control][data.category]);
			luts.loaded[data.control].controls[data.category].status = "loaded";
		}

		// If we add more of the same block while the initial is being in 'loading'
		else if (luts.loaded[data.control].controls[data.category].status == "loading") {
			return await new Promise(resolve => {
				let interval = setInterval(_ => {
					if (luts.loaded[data.control].controls[data.category].status == "loaded") {
						clearInterval(interval);
						resolve();
					}
				}, 500);
			});
		}
	}

	addPass() {
		let renderPass = gpu.createRenderPass();
		gpu.addPassToComposer(renderPass, "toMiddle");
		return renderPass;
	}

	showPreviews() {
		if (!lutify.canvasMouseDown) {
			UI.togglePreviewsContainer();
			lutPreviewer.switchCanvases(lutify.getActiveBlock().name);
			UI.updateSelectedPreview(lutify.getActiveBlock().selectedPreview);
		}

		lutPreviewer.cloneMainComposerPasses();
		lutPreviewer.addPass(lutify.getActiveBlock().control, lutify.getActiveBlock().name, undefined, lutify.getActiveBlock().blendingMode);
		lutPreviewer.render();
	}

	opacitySliderHandler($element) {
		let opacityValue = $element.find(".opacity_slider").val();
		let calcOpacityValue = opacityValue * 0.01;

		$element.find(".opacity-input").val(opacityValue);

		lutify.getActiveBlock().opacity = opacityValue;
		lutify.getActiveBlock().passes[0].uniforms.opacity.value = calcOpacityValue;

		lutPreviewer.updateOpacity(calcOpacityValue);
		UI.setPreviewerOpacity(lutify.getActiveBlock().opacity);

		gpu.render();
		lutPreviewer.render();
	}

	opacityInputHandler($element) {
		let opacityValue = $element.find(".opacity-input").val();
		let opacitySlider = $element.find(".opacity_slider");

		if (opacityValue > this.opacity.maxValue) opacityValue = this.opacity.maxValue;
		if (opacityValue < this.opacity.minValue) opacityValue = this.opacity.minValue;

		opacitySlider.val(opacityValue);
		opacitySlider.trigger("input");
	}

	toggleControlSelector($el) {
		let itemsContainer = $el.siblings(".lut-selector__items-container");
		if (itemsContainer.is(":visible")) itemsContainer.hide();
		else itemsContainer.show();
	}

	removeLutSelection(e) {
		e.stopPropagation();
		lutify.getActiveBlock().selectedPreview = null;
		lutify.getActiveBlock().selectedPreviewName = null;
		lutify.getActiveBlock().passes[0].enabled = false;
		gpu.render();
		this.showPreviews();
		this.updateDropdownSelectionLabel();
	}

	updateDropdownSelectionLabel() {
		if (lutify.getActiveBlock().selectedPreview !== null) {
			// let lutName = UI.getPreviewDescription(lutify.getActiveBlock().selectedPreview);
			let lutName = lutify.getActiveBlock().selectedPreviewName;
			UI.getActiveBlock()
				.find(".selected-lut-name")
				.html("Look: " + lutName);

			UI.getActiveBlock()
				.find(`.lut-selector__items-container .--selected`)
				.removeClass("--selected");

			UI.getActiveBlock()
				.find(`.lut-selector__items-container [data-composer-index="${lutify.getActiveBlock().selectedPreview}"]`)
				.addClass("--selected");
		} else {
			UI.getActiveBlock()
				.find(".selected-lut-name")
				.html("Select...");

			UI.getActiveBlock()
				.find(`.lut-selector__items-container .--selected`)
				.removeClass("--selected");
		}
	}

	updateLutsDropdownList($block, data) {
		let selectedLuts = luts[data.control][data.category];
		let lutsList = UI.createLutDropdownList(selectedLuts);

		// if (data.selectedPreview) {
		// 	$(lutsList).find(`[data-composer-index="${data.selectedPreview}"]`).addClass('--selected');
		// }
		$block.find(".lut-selector__items-container").html("");
		$block.find(".lut-selector__items-container").html(lutsList);
		$block.find(".lut-selector__items-container > span").on("click", e => this.lutDropdownSelection(e.currentTarget));
	}

	lutDropdownSelection(selectedLut) {
		let $blockOptions = $(selectedLut).closest(".block_options");
		$blockOptions.find(".lut-selector__items-container").hide();

		if (
			lutify.getActiveBlock().selectedPreview == null ||
			selectedLut.dataset.composerIndex !== lutify.getActiveBlock().selectedPreview.toString()
		) {
			$(`#previews-list-container > .list-item[data-composer-index="${selectedLut.dataset.composerIndex}"]`).trigger("click");
			this.updateDropdownSelectionLabel();
		}
	}

	resetBlock($element, e) {
		e.stopPropagation();
		// $element.find(".selected-lut-name").html("Select...");
		$element.find(".opacity-input").val(100);
		$element.find(".opacity-input").trigger("change");
		$element.find('.blending-mode__items-container > span[data-id="0"]').trigger("click");

		UI.deselectPreview();
		UI.scrollToSelectedPreview();
		lutify.getActiveBlock().selectedPreview = null;
		lutify.getActiveBlock().selectedPreviewName = null;

		this.updateDropdownSelectionLabel();

		let renderPass = gpu.createRenderPass();
		renderPass.uid = lutify.getActiveBlock().passes[0].uid;
		let passIndex = gpu.getPassIndexById(lutify.getActiveBlock().passes[0].uid);
		lutify.getActiveBlock().passes[0] = renderPass;
		gpu.composer.passes[passIndex] = lutify.getActiveBlock().passes[0];

		gpu.render();
		lutPreviewer.render();
	}

	applyCompare($block, data) {
		if (data.selectedPreviewName !== null) {
			let composerIndex = luts.getComposerIndexByName(data.control, data.category, data.selectedPreviewName);
			let passIndex = lutPreviewer.getPassIndexById(lutPreviewer.composers[composerIndex], lutify.getActiveBlock().passes[0].uid);

			lutify.getActiveBlock().passes[0] = lutPreviewer.composers[composerIndex].passes[passIndex];
			lutify.getActiveBlock().selectedPreview = composerIndex;
			lutify.getActiveBlock().selectedPreviewName = data.selectedPreviewName;
			gpu.composer.passes[passIndex] = lutify.getActiveBlock().passes[0];

			lutify.getActiveBlock().collapsedPreviews = data.collapsedPreviews;

			$block.find(".opacity-input").val(parseInt(data.opacity));
			$block.find(".opacity-input").trigger("change");
			$block.find(".controls-wrapper .switch > input").trigger("click");
			this.updateDropdownSelectionLabel();
		}

		if (data.blendingMode !== 0) $block.find(`.blending-mode__items-container > span[data-id="${data.blendingMode}"]`).trigger("click");
	}
}
